import { render } from "./EditProfile.vue?vue&type=template&id=5112dc0e&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"

import "./EditProfile.vue?vue&type=style&index=0&id=5112dc0e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5112dc0e"

export default script